import { jsxs, jsx } from "react/jsx-runtime";
const IconTipSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M7.5 15.797a.831.831 0 0 1-.833-.833v-1.63a7.468 7.468 0 0 0-1.238-2.195l-.23-.326a5.833 5.833 0 1 1 9.603 0l-.23.326a7.466 7.466 0 0 0-1.238 2.194v1.61a.833.833 0 0 1-1.667 0v-1.61c0-.912.732-2.015 1.547-3.16l.217-.307a4.167 4.167 0 1 0-6.862 0l.218.306c.815 1.146 1.547 2.25 1.547 3.161v1.631a.833.833 0 0 1-.834.833Z" }),
      /* @__PURE__ */ jsx("path", { d: "M11.071 18.333H8.928A2.3 2.3 0 0 1 6.666 16v-1.833a.833.833 0 0 1 .834-.834h5a.836.836 0 0 1 .833.834V16a2.301 2.301 0 0 1-2.262 2.333ZM8.333 15v1a.634.634 0 0 0 .595.667h2.143a.634.634 0 0 0 .595-.667v-1H8.333Zm10.834-6.667H17.5a.833.833 0 1 1 0-1.666h1.667a.833.833 0 1 1 0 1.666Zm-1.229 4.584a.83.83 0 0 1-.416-.112l-1.444-.833a.832.832 0 0 1 .201-1.527.834.834 0 0 1 .633.083l1.443.833a.833.833 0 0 1-.417 1.556Zm-1.442-8.334a.833.833 0 0 1-.418-1.555l1.444-.833a.833.833 0 1 1 .833 1.444l-1.444.833a.829.829 0 0 1-.415.111ZM2.5 8.333H.833a.833.833 0 0 1 0-1.666H2.5a.833.833 0 0 1 0 1.666Zm-.438 4.584a.834.834 0 0 1-.418-1.556l1.444-.833a.833.833 0 1 1 .833 1.444l-1.443.833a.83.83 0 0 1-.416.112Zm1.442-8.334a.829.829 0 0 1-.415-.111l-1.444-.833a.833.833 0 0 1 .833-1.444l1.444.833a.833.833 0 0 1-.418 1.555Zm8.996 3.75a.833.833 0 0 1-.833-.833A1.67 1.67 0 0 0 10 5.833a.833.833 0 0 1 0-1.666A3.337 3.337 0 0 1 13.334 7.5a.835.835 0 0 1-.834.833Z" }),
      /* @__PURE__ */ jsx("path", { d: "M11.666 17.5a1.667 1.667 0 0 1-3.333 0" })
    ]
  }
);
export {
  IconTipSvg
};
